//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import AddEditGroupMembers from "@/components/Admin/RolesAndUsers/AddEditGroupMembers/add-edit-group-members.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AppPermissionsUserGroupView from "./AppPermissionsUserGroupView.vue";
import AppPermissionsViewDetails from "./AppPermissionsViewDetails.vue";
import AppChangeOwner from "./AppChangeOwner.vue";
import AppEditPermissions from "./AppEditPermissions.vue";
import { SIDEBAR_SUBROLES } from "./appPermissionsRolesConst";

export default {
    name: "AppPermissionsRoles",
    components: {
        AppPermissionsUserGroupView,
        AppPermissionsViewDetails,
        AppChangeOwner,
        AddEditGroupMembers,
        AppEditPermissions,
        AQButton,
        AQModal,
        AQCard
    },
    props: {
        roleItem: {
            type: Object,
            default: () => {}
        },
        viewItems: {
            type: Boolean,
            default: false
        },
        editMode: {
            type: Boolean,
            default: true
        },
        triggerShowSearch: {
            type: Boolean,
            default: false
        },
        constraints: {
            type: Object,
            default: () => ({})
        },
        dynamicPermissions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showModal: false,
            viewDetails: false,
            changeOwner: false,
            selectedUserGroupPermissions: [],
            alreadySelectedPermissions: [],
            rolePermissionsUserGroups: [],
            editPermissionModal: "",
            newItemsAdded: [],
            groupsToRemove: ["ADMIN"],
            opened: false,
            code: "",
            rerenderIndex: 0,
            cardOpen: false
        };
    },
    computed: {
        getNameContainer() {
            const { name } = this.constraints || {};
            return name || this.$t(`applicationPermissions.${this.roleItem.code}Role`);
        },
        getDescriptionContainer() {
            const { description, noDescription } = this.constraints || {};
            return noDescription ? "" : (description
            || (this.$te(`applicationPermissions.${this.roleItem.code}RoleDesc`) ? this.$t(`applicationPermissions.${this.roleItem.code}RoleDesc`) : ""));
        },
        getUsersGroupsLength() {
            let permissionDescription; const
                allData = [...this.rolePermissionsUserGroups, ...this.newItemsAdded];
            if (this.roleItem.code === "OWNER") {
                permissionDescription = this.$t("applicationPermissions.permissionOnlyOneUser");
            } else {
                let users = 0; let
                    groups = 0;
                allData.forEach(element => {
                    if (element.email) {
                        users += 1;
                    } else {
                        groups += 1;
                    }
                });
                const checkUsers = users ? `${users} ${this.$t(`applicationPermissions.${users === 1 ? "user" : "users"}`)} ` : "";
                const checkMiddleAnd = users && groups ? this.$t("applicationPermissions.permissionsSecond") : "";
                const checkGroups = groups ? `${groups} ${this.$t(`applicationPermissions.${groups === 1 ? "group" : "groups"}`)}` : "";

                permissionDescription = (users || groups) ? this.$t("applicationPermissions.permissionsFirst") + checkUsers + checkMiddleAnd + checkGroups
                    : this.$t("applicationPermissions.noUsersAndGroups");
            }

            return permissionDescription;
        },
        isOwner() {
            return this.roleItem.code === "OWNER";
        },
        showViewDetails() {
            const constraints = [...SIDEBAR_SUBROLES, "TASKS_MANAGER", "INITIATOR", "SIDEBAR"];
            return !constraints.includes(this.roleItem.code);
        },
        hasOwner() {
            return this.rolePermissionsUserGroups && this.rolePermissionsUserGroups[0] ? this.rolePermissionsUserGroups[0] : null;
        },
        getModalTitle() {
            const title = this.viewDetails ? "applicationPermsViewDet.title" : "applicationPermissions.givePermissions";
            return this.$t(title);
        },
        checkIfExistingItems() {
            return this.rolePermissionsUserGroups && this.rolePermissionsUserGroups.length;
        },
        checkIfNewlyAddedItems() {
            return this.newItemsAdded && this.newItemsAdded.length;
        },
        computedSave() {
            return this.viewDetails ? null : { label: this.$t("admin.usersAndRoles.permissionsModal.saveBtn"), disabled: false };
        }
    },
    watch: {
        viewItems: {
            handler(newValue) {
                if (!this.isOwner) {
                    if (newValue) {
                        this.cardOpen = true;
                        this.$emit("tabOpened");
                    } else {
                        this.cardOpen = false;
                    }
                }
            }
        },
        roleItem: {
            handler(newValue) {
                if (this.opened && newValue && newValue.code !== "OWNER") {
                    this.getUsersAndGroups(true);
                }
            },
            immediate: true
        },
        showModal(newValue) {
            this.$emit("openCloseModal", newValue);
        },
        editPermissionModal(newValue, oldValue) {
            if (newValue && oldValue) {
                this.$emit("edit");
                this.editPermissionModal = null;
            }
        }
    },
    deactivated() {
        this.rerenderIndex++;
    },
    created() {
        this.code = this.roleItem.code;
        this.$root.$on("oneAtATime-permissions", () => {
            if (this.opened && this.$oneAtATime.state.$currentRoomEmpty) {
                this.getUsersAndGroups();
            }
        });
    },
    activated() {
        if (this.opened) {
            this.getUsersAndGroups();
        }
    },
    mounted() {
        if (this.isOwner || this.viewItems) {
            this.collapseShow();
        }
    },
    methods: {
        ...mapActions("apps", ["actGetRoleUsersGroups", "actAddRemoveUsersGroupsRole", "actGetCurrentAppUserPermissions"]),
        removePermission() {
            this.$emit("edit");
            this.editPermissionModal = null;
        },
        editItemPermission(item) {
            this.editPermissionModal = item;
            this.$emit("modalOpenStatus", true);
        },
        openChangeAction() {
            if (this.isOwner) {
                this.changeOwner = true;
            } else {
                this.alreadySelectedPermissions = [...this.rolePermissionsUserGroups, ...this.newItemsAdded].map(element => element.id);
                this.showModal = true;
            }
            this.$emit("modalOpenStatus", true);
        },
        changeData(data) {
            if (data) {
                if (this.isOwner) {
                    this.rolePermissionsUserGroups = [data];
                } else {
                    this.rolePermissionsUserGroups.push(data);
                }
            }
            this.changeOwner = false;
            this.$emit("modalOpenStatus", false);
        },
        deleteItem(item, newItem) {
            const itemType = item.type === "GROUP";
            const roleData = {
                groupIds: itemType ? [item.id] : [],
                userIds: itemType ? [] : [item.id],
                roleCode: this.roleItem.code
            };
            if (this.roleItem.id) {
                roleData.roleId = this.roleItem.id;
            }
            this.actAddRemoveUsersGroupsRole({ roleData, actionDelete: true }).then(
                () => {
                    const dataList = newItem ? this.newItemsAdded : this.rolePermissionsUserGroups;
                    const index = dataList.findIndex(element => element.id === item.id);
                    this.$emit("delete");
                    if (index !== -1) {
                        dataList.splice(index, 1);
                    }
                    this.setNotification("removeConfirmationMsg");
                    this.$emit("modalOpenStatus", false);
                }
            );
        },
        cancelShowSearch(data) {
            this.$emit("modalOpenStatus", !!data);
        },
        openPermsDetails() {
            this.showModal = true;
            this.viewDetails = true;
            this.$emit("modalOpenStatus", this.showModal);
        },
        actionModal(action) {
            if (action === "save") {
                this.$emit("input");
                if (this.selectedUserGroupPermissions && this.selectedUserGroupPermissions.length) {
                    const groupIds = [];
                    const userIds = [];
                    const roleCode = this.roleItem.code;

                    this.selectedUserGroupPermissions.forEach(element => {
                        if (element.type === "GROUP") {
                            groupIds.push(element.id);
                        } else {
                            userIds.push(element.id);
                        }
                    });
                    const roleData = { groupIds, userIds, roleCode };
                    if (this.roleItem.id) {
                        roleData.roleId = this.roleItem.id;
                    }

                    this.actAddRemoveUsersGroupsRole({ roleData }).then(
                        () => {
                            if (this.roleItem.children) {
                                this.$emit("add");
                            } else {
                                this.newItemsAdded = this.setGroupsUsersOrder([...this.newItemsAdded, ...this.selectedUserGroupPermissions]);
                            }
                            this.selectedUserGroupPermissions = [];
                            this.showModal = false;
                            this.viewDetails = false;
                            this.$emit("modalOpenStatus", this.showModal);
                            this.setNotification("addConfirmationMsg");
                        }
                    );
                } else {
                    this.showModal = false;
                    this.viewDetails = false;
                    this.$emit("modalOpenStatus", this.showModal);
                }
            } else {
                this.showModal = false;
                this.viewDetails = false;
                this.$emit("modalOpenStatus", this.showModal);
            }
        },
        setNotification(message) {
            this.$toast.showNotify({
                type: "success",
                message: this.$t(`applicationPermissions.${message}`)
            });
        },
        setGroupsUsersOrder(data) {
            const groups = []; const
                users = [];
            data.forEach(element => {
                if (element.type === "GROUP") {
                    groups.push(element);
                } else {
                    users.push(element);
                }
            });
            return [...groups, ...users];
        },
        getUsersAndGroups(alreadyLoaded) {
            if (this.roleItem && this.roleItem.children) {
                this.rolePermissionsUserGroups = this.roleItem.children;
            } else {
                const { code: roleCode, id: roleId } = this.roleItem;
                this.actGetRoleUsersGroups({ roleCode, roleId }).then(
                    data => {
                        const dataPermissions = data && data.data && data.data.children ? data.data.children : [];
                        if (alreadyLoaded) {
                            if (dataPermissions.length) {
                                const finalPermissionsData = [];
                                const tempoNewItemAdded = [];

                                dataPermissions.forEach(element => {
                                    const itemAlreadyExist = this.newItemsAdded.find(item => item.id === element.id);
                                    const oldItem = this.rolePermissionsUserGroups.find(item => item.id === element.id);

                                    if (itemAlreadyExist) {
                                        tempoNewItemAdded.push(element);
                                    } else if (oldItem) {
                                        finalPermissionsData.push(element);
                                    } else {
                                        tempoNewItemAdded.push(element);
                                    }
                                });
                                this.rolePermissionsUserGroups = finalPermissionsData;
                                this.newItemsAdded = tempoNewItemAdded;
                            } else {
                                this.rolePermissionsUserGroups = [];
                                this.newItemsAdded = [];
                            }
                        } else {
                            this.rolePermissionsUserGroups = dataPermissions;
                        }
                    }
                );
            }
        },
        collapseShow() {
            this.opened = true;
            this.getUsersAndGroups();
        },
        collapseHide() {
            this.opened = false;
            this.newItemsAdded = [];
        },
        cardOpenEvent(event) {
            if (event) {
                this.collapseShow();
            } else {
                this.collapseHide();
            }
        }
    }
};
